export default "__VITE_ASSET__DkyZECbA__"